/** Great-circle distance in miles between two lat/lng points (Haversine). */
export function haversineMiles(
  a: { lat: number; lng: number },
  b: { lat: number; lng: number },
): number {
  const R = 3958.7613; // Earth radius in miles
  const toRad = (d: number) => (d * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.sin(dLng / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
  return 2 * R * Math.asin(Math.sqrt(h));
}

/** Rounded miles for display, or undefined if either point is missing coords. */
export function milesBetween(
  home: { lat?: number; lng?: number } | undefined,
  venue: { lat?: number; lng?: number } | undefined,
): number | undefined {
  if (
    !home ||
    !venue ||
    home.lat === undefined ||
    home.lng === undefined ||
    venue.lat === undefined ||
    venue.lng === undefined
  ) {
    return undefined;
  }
  return Math.round(
    haversineMiles(
      { lat: home.lat, lng: home.lng },
      { lat: venue.lat, lng: venue.lng },
    ),
  );
}
